<template>
  <b-modal
    size="xl"
    :visible="visible"
    centered
    hide-footer
    hide-header-close
    class="v3_modal v2_modal font_Montserrat"
    body-class="pb-5 font_size_1125rem"
  >
    <div
      class="font_size_1250rem font_weight_bold v3_color_black_knight"
    >
      <span v-if="content && content.heading" v-html="content.heading"/>
    </div>
    <v-wait :for="contentLoaderName">
      <template slot="waiting">
        <HalfCircleSpinner />
        <div class="spinner-message my-3 text-center">
          Loading data...
        </div>
      </template>
      <b-row>
        <b-col cols="12" class="pt-3">
          <p v-if="content && content.intro_p" v-html="content.intro_p" />
          <ul class="list-style-disc pl-3">
            <li v-if="content && content.bullet1" v-html="content.bullet1" />
            <li v-if="content && content.bullet2" v-html="content.bullet2" />
            <li v-if="content && content.bullet3" v-html="content.bullet3" />
            <li v-if="content && content.bullet4" v-html="content.bullet4" />
            <li v-if="content && content.bullet5" v-html="content.bullet5" />
            <li v-if="content && content.bullet6" v-html="content.bullet6" />
          </ul>
          <p>
            <b>Questions?</b> Click
            <i
              class="mdi mdi-information-outline"
              aria-hidden="true"
              style="position: relative; top: 3px;"
            />
            for instructions and context. Access our
            <router-link to="/help" class="phairify-link">
              Knowledge Library
            </router-link>
            anytime.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <p v-if="content && content.closing" v-html="content.closing" />
          <div class="d-flex align-items-center justify-content-center mt-3">
            <b-button
              variant="v3_teal_outline"
              @click="onGetStarted"
              :disabled="loading"
            >
              <b-spinner v-if="loading" small />
              <span v-else>Get Started</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </v-wait>
  </b-modal>
</template>

<script>
import Api from '@/providers/Api';
import { HalfCircleSpinner } from 'epic-spinners';
import sanitizeHtml from 'sanitize-html';

export default {
  name: 'WelcomeModal',
  components: {
    HalfCircleSpinner,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      content: null,
    };
  },
  created: async function () {
    this.$wait.start(this.contentLoaderName);
    try {
      this.content = await Api.getWelcomeToPhairifyContent();
    } catch {
      this.$toasted.error(
        'Unable to update page content. Please try again later',
        { duration: 3000 }
      );
    } finally {
      this.$wait.end(this.contentLoaderName);
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', this.onClose);
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::hidden');
  },
  computed: {
    contentLoaderName: function () {
      return this.$options.name + '_contentLoading';
    },
    user: function () {
      return this.$store.state.user;
    },
    specialty: function () {
      const specialty =
        this.user &&
        this.user.society.specialties.find(
          (s) => s.id === this.user.specialty_id
        );
      return specialty ? specialty.title : '';
    },
  },
  methods: {
    onClose: function () {
      this.$emit('close');
    },
    onGetStarted: function () {
      this.$emit('getStarted');
    },
  },
};
</script>

<style scoped></style>
